import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { SimpleSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { trace } from '@opentelemetry/api';

import { SemanticResourceAttributes } from '@opentelemetry/semantic-conventions';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { getScopedKey } from './components/common/Helper';

// Configure exporter (e.g., to OpenTelemetry collector or APM endpoint)
const exporter = new OTLPTraceExporter({
    //   url: 'http://localhost:4318/v1/traces', // default OTLP/HTTP endpoint
    // url: 'http://13.235.102.233:4319/v1/traces',
    url: process.env.REACT_APP_TRACES_API_BASE_URL,
    headers: {}
});

const resource = resourceFromAttributes({
    [SemanticResourceAttributes.SERVICE_NAME]: getScopedKey('finops_frontend'),
})

const provider = new WebTracerProvider({
    resource,
    spanProcessors: [new SimpleSpanProcessor(exporter)]
});

// Register automatic instrumentations
provider.register({
    contextManager: new ZoneContextManager(),
});

// registerInstrumentations({
//     instrumentations: [
//         new FetchInstrumentation({
//             // propagateTraceHeaderCorsUrls: /.*/, // propagate headers for all URLs
//             propagateTraceHeaderCorsUrls: [/./], // propagate headers for all URLs
//             // applyCustomAttributesOnSpan(span, request, response) {
//             //     try {
//             //         const url = new URL(request.url);
//             //         const method = request.method || 'GET';

//             //         // Set the span name to something like: GET /api/users
//             //         console.log(`trace name------ ${method} ${url.pathname}`)
//             //         span.updateName(`${method} ${url.pathname}`);
//             //         span.setAttribute('custom.span_name', `${method} ${url.pathname}`);

//             //         // Optionally add custom attributes too
//             //         span.setAttribute('http.url', url.href);
//             //         span.setAttribute('http.path', url.pathname);
//             //     } catch (e) {
//             //         console.warn('Could not parse URL for span', e);
//             //     }
//             // },
//         }),
//         new XMLHttpRequestInstrumentation(),
//     ],
// });

console.log('OpenTelemetry initialized in React');

export const tracer = trace.getTracer('finops-web-app');
